import React, { useEffect, useState } from 'react';
import styles from './styles';
import renderHTML from 'react-render-html';
import { mdiFileOutline } from '@mdi/js';
import Icon from '@mdi/react';
import knowledgebaseApi from '../../api/knowledgebase';
import KnowledgebaseInfoImage from './KnowledgebaseInfoImage';
import './knowledgebase.scss';
import { Link } from 'react-router-dom';
import { Stream } from '@cloudflare/stream-react';
import { jwtDecode } from 'jwt-decode';
import FeedApi from '../../api/feed';

const KnowledgebaseItem = (props) => {
  const [state, setState] = useState({
    videoToken: props.item.video ? props.item.video.token : '',
    newVideoToken: '',
  });

  useEffect(() => {
    const { type, video_id } = props.item;
    const { taskId, updateTask } = props;
    if (taskId && ((type === 'INFO' && !video_id) || type === 'DETAILS')) updateTask(taskId);
  }, []);

  const renderTitle = (type, title) => {
    return (
      <div>
        {type === 'DETAILS' && <div className="post-detail-title">{title}</div>}
        {(type === 'INFO' || type === 'FILE') && <div className="post-title">{title}</div>}
      </div>
    );
  };

  const onClickPlayVideo = async () => {
    try {
      const { taskId, updateTask } = props;
      taskId && updateTask(taskId);
      const videoId = props.item.video_id;
      const currentTime = Date.now() / 1000;
      const videoJWTToken = jwtDecode(state.videoToken);
      if (videoJWTToken.exp - currentTime < 0) {
        const streamUrlResp = (await FeedApi.getVideoStreamURL(videoId)) || {};
        const newToken = streamUrlResp.video ? streamUrlResp.video.token : '';
        if (newToken)
          setState({
            newVideoToken: newToken,
          });
      }
    } catch (err) {}
  };

  const renderFile = (file) => {
    const onClickFileItem = async () => {
      const { type } = props.item;
      const { taskId, updateTask } = props;
      let amazonS3fileUriResp = await knowledgebaseApi.getAmazonS3SignedFileUrl(file.fileUri);
      if (amazonS3fileUriResp && amazonS3fileUriResp.file_uri) {
        window.open(amazonS3fileUriResp.file_uri, '_blank');
      }
      if (type === 'FILE' && taskId) {
        updateTask(taskId);
      }
    };
    const getFileTypeAndSize = () => {
      try {
        if (file.size > 0) {
          const k = 1024;
          const dm = 0;
          const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
          const i = Math.floor(Math.log(file.size) / Math.log(k));
          const size = parseFloat((file.size / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
          return `${file.type.toUpperCase()} - ${size}`;
        }
        return `${file.type.toUpperCase()}`;
      } catch (err) {
        console.log(err);
        return 'PDF';
      }
    };
    return (
      <div style={styles.fileContainer} onClick={onClickFileItem}>
        <div style={styles.fileIcon}>
          <Icon path={mdiFileOutline} size={1.2} color="var(--primary-color)" />
        </div>
        <div>
          <div style={styles.fileName}>{file.title}</div>
          <div style={styles.fileTypeSize}>{getFileTypeAndSize()}</div>
        </div>
      </div>
    );
  };

  const renderDetails = (detailsList) => {
    return (
      <div>
        {detailsList.map((detailItem) => (
          <div className="post-detail-container">
            {detailItem.type === 'WEB_ADDRESS' && (
              <a href={detailItem.value} className="detail-label" target="_blank" rel="noreferrer">
                {detailItem.value}
              </a>
            )}
            {detailItem.type === 'EMAIL_ADDRESS' && (
              <a
                href={`mailto:${detailItem.value}`}
                className="detail-label"
                target="_blank"
                rel="noreferrer"
              >
                {detailItem.value}
              </a>
            )}
            {detailItem.type === 'PHONE_NUMBER' && detailItem.value}
          </div>
        ))}
      </div>
    );
  };

  const renderVideo = (videoUrl) => {
    const { taskId, updateTask } = props;

    return state.videoToken || state.newVideoToken ? (
      <Stream
        src={state.newVideoToken ? state.newVideoToken : state.videoToken}
        onPlay={() => {
          onClickPlayVideo();
          taskId && updateTask(taskId);
        }}
        controls
        autoplay={state.newVideoToken ? true : false}
        preload
        height="300px"
        width="100%"
      ></Stream>
    ) : null;
  };

  const renderItemHeader = (categories = [], type, withImage) => {
    const visibleCategories =
      categories.length > 2 ? categories.slice(0, 2) : categories;
  
    const categoryLabel = visibleCategories.join(', ');
  
    const typeLabel =
      type === 'INFO' ? 'Info' :
      type === 'DETAILS' ? 'Details' :
      'File';
  
    return (
      <div
        className={`post-headerbar-container ${
          withImage ? 'post-headerbar-container-with-image' : ''
        }`}
      >
        <div className="post-headerbar-typelabel">{typeLabel}</div>
        <div style={{ display: 'flex', flex: 1 }} />
        <div
          className={`post-headerbar-categorylabel ${
            withImage ? 'categorylabel-with-image' : ''
          }`}
        >
          {categoryLabel}
        </div>
      </div>
    );
  };

  const { title, description, categories, type, files, details, image, id } = props.item;
  const { viewOnly } = props;
  const isImagePresent = image && image.url ? true : false;
  return (
    <div className={`post-container ${viewOnly ? 'post-container-knowledgebase' : ''}`}>
      {viewOnly ? (
        <div className="post-header-container">
          {image && image.url ? (
            <div className="knowledgebase-item-content-image-holder">
              <KnowledgebaseInfoImage image={image} />
            </div>
          ) : null}
          {renderItemHeader(categories, type, isImagePresent)}
        </div>
      ) : (
        <Link
          to={{
            pathname: `/knowledgebase-item/${id}`,
          }}
          state= {{ item: props.item, test: 'Hello' }}
        >
          <div className="post-header-container">
            {image && image.url ? (
              <div className="knowledgebase-item-content-image-holder">
                <KnowledgebaseInfoImage image={image} />
              </div>
            ) : null}
            {renderItemHeader(categories, type, isImagePresent)}
          </div>
        </Link>
      )}
      <div style={{ padding: 15 }}>
        {renderTitle(type, title)}
        {renderDetails(details)}
        {description && <div className="post-information-content">{renderHTML(description)}</div>}
        {renderVideo()}
        <div style={{ marginTop: 20 }}>{files.map((file) => renderFile(file))}</div>
      </div>
    </div>
  );
};

export default KnowledgebaseItem;